import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'ui';
import type { IconName } from 'ui';

import type { PracticeOrigin } from '../../../utils/challengeTypeUtils';
import './PracticeOriginLabel.scss';

type PracticeOriginLabelProps = {
  /** Whether the session was created by the tutor (`'tutor'`) or by the student (`'student'`). */
  origin: PracticeOrigin;
};

/** Leading icon per origin: the AI sparkle for the tutor, a user glyph for the student. */
const ORIGIN_ICON: Record<PracticeOrigin, IconName> = {
  student: 'bar-menu-user',
  tutor: 'ai',
};

/**
 * PracticeOriginLabel - Brand-coloured label shown above the practice card title
 * that states who created the session: "From your tutor" or "Created by you".
 * The leading icon inherits the label colour via `color="inherit"`.
 */
function PracticeOriginLabel({ origin }: Readonly<PracticeOriginLabelProps>): JSX.Element {
  const { t } = useTranslation(['chatbot']);

  const label = origin === 'student' ? t('student_recommendations_origin_student') : t('student_recommendations_origin_tutor');

  return (
    <span className={clsx('practice-origin-label', `practice-origin-label--${origin}`)}>
      <Icon color="inherit" name={ORIGIN_ICON[origin]} size="sm" />
      {label}
    </span>
  );
}

export default PracticeOriginLabel;
